/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

var p = new Pjax({
  elements: "a",
  selectors: ["title", "#main-content"]
});


var openClose;
var openPanel;
var closePanel;

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {

    // All pages
    'common': {
      init: function() {
        // maps
        function showGoogleMaps() {

          /**
           *
           * @param marker
           * @param num
           */
          function attachActionToMarker(marker, data) {
            google.maps.event.addListener(marker, 'click', function() {
              p.loadUrl(data.permalink, Pjax.clone(p.options));
            });
          }


          var bounds = new google.maps.LatLngBounds();

          var mapOptions = {
            zoom: 16, // initialize zoom level - the max value is 21
            maxZoom: 16 ,
            streetViewControl: false, // hide the yellow Street View pegman
            scaleControl: true, // allow users to zoom the Google Map
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            mapTypeControl: false,
            panControl: false,
            panControlOptions:{
              position: google.maps.ControlPosition.RIGHT_TOP
            },
            zoomControlOptions: {
              position: google.maps.ControlPosition.RIGHT_CENTER
            },
            styles:
                [
                  {
                    "featureType": "all",
                    "elementType": "labels",
                    "stylers": [
                      {
                        "visibility": "off"
                      }
                    ]
                  },
                  {
                    "featureType": "administrative",
                    "elementType": "geometry",
                    "stylers": [
                      {
                        "color": "#ffebc5"
                      },
                      {
                        "lightness": "-10"
                      }
                    ]
                  },
                  {
                    "featureType": "administrative",
                    "elementType": "geometry.stroke",
                    "stylers": [
                      {
                        "color": "#675a4b"
                      }
                    ]
                  },
                  {
                    "featureType": "administrative.country",
                    "elementType": "labels",
                    "stylers": [
                      {
                        "visibility": "off"
                      }
                    ]
                  },
                  {
                    "featureType": "administrative.country",
                    "elementType": "labels.text",
                    "stylers": [
                      {
                        "visibility": "off"
                      }
                    ]
                  },
                  {
                    "featureType": "administrative.country",
                    "elementType": "labels.text.fill",
                    "stylers": [
                      {
                        "color": "#b70046"
                      }
                    ]
                  },
                  {
                    "featureType": "administrative.province",
                    "elementType": "geometry.fill",
                    "stylers": [
                      {
                        "visibility": "off"
                      }
                    ]
                  },
                  {
                    "featureType": "administrative.province",
                    "elementType": "geometry.stroke",
                    "stylers": [
                      {
                        "color": "#675a4b"
                      },
                      {
                        "weight": "0.50"
                      }
                    ]
                  },
                  {
                    "featureType": "administrative.province",
                    "elementType": "labels",
                    "stylers": [
                      {
                        "visibility": "off"
                      }
                    ]
                  },
                  {
                    "featureType": "administrative.province",
                    "elementType": "labels.text.fill",
                    "stylers": [
                      {
                        "color": "#675a4b"
                      }
                    ]
                  },
                  {
                    "featureType": "administrative.locality",
                    "elementType": "all",
                    "stylers": [
                      {
                        "visibility": "simplified"
                      }
                    ]
                  },
                  {
                    "featureType": "administrative.locality",
                    "elementType": "labels",
                    "stylers": [
                      {
                        "visibility": "off"
                      }
                    ]
                  },
                  {
                    "featureType": "administrative.locality",
                    "elementType": "labels.text.fill",
                    "stylers": [
                      {
                        "color": "#ff850a"
                      }
                    ]
                  },
                  {
                    "featureType": "administrative.neighborhood",
                    "elementType": "geometry",
                    "stylers": [
                      {
                        "visibility": "on"
                      }
                    ]
                  },
                  {
                    "featureType": "administrative.neighborhood",
                    "elementType": "labels",
                    "stylers": [
                      {
                        "visibility": "off"
                      }
                    ]
                  },
                  {
                    "featureType": "landscape",
                    "elementType": "all",
                    "stylers": [
                      {
                        "color": "#f2f2f2"
                      }
                    ]
                  },
                  {
                    "featureType": "landscape",
                    "elementType": "geometry.fill",
                    "stylers": [
                      {
                        "saturation": "-71"
                      },
                      {
                        "lightness": "-2"
                      },
                      {
                        "color": "#ffebc5"
                      }
                    ]
                  },
                  {
                    "featureType": "landscape.natural",
                    "elementType": "labels",
                    "stylers": [
                      {
                        "visibility": "off"
                      }
                    ]
                  },
                  {
                    "featureType": "poi",
                    "elementType": "all",
                    "stylers": [
                      {
                        "visibility": "off"
                      }
                    ]
                  },
                  {
                    "featureType": "poi",
                    "elementType": "labels",
                    "stylers": [
                      {
                        "visibility": "off"
                      }
                    ]
                  },
                  {
                    "featureType": "poi.park",
                    "elementType": "geometry.fill",
                    "stylers": [
                      {
                        "color": "#70bfaf"
                      }
                    ]
                  },
                  {
                    "featureType": "road",
                    "elementType": "all",
                    "stylers": [
                      {
                        "saturation": -100
                      },
                      {
                        "lightness": 45
                      },
                      {
                        "visibility": "simplified"
                      }
                    ]
                  },
                  {
                    "featureType": "road",
                    "elementType": "labels",
                    "stylers": [
                      {
                        "visibility": "off"
                      }
                    ]
                  },
                  {
                    "featureType": "road.highway",
                    "elementType": "all",
                    "stylers": [
                      {
                        "visibility": "simplified"
                      }
                    ]
                  },
                  {
                    "featureType": "road.highway",
                    "elementType": "geometry.fill",
                    "stylers": [
                      {
                        "color": "#ffffff"
                      }
                    ]
                  },
                  {
                    "featureType": "road.highway",
                    "elementType": "geometry.stroke",
                    "stylers": [
                      {
                        "color": "#675a4c"
                      }
                    ]
                  },
                  {
                    "featureType": "road.highway",
                    "elementType": "labels",
                    "stylers": [
                      {
                        "visibility": "off"
                      }
                    ]
                  },
                  {
                    "featureType": "road.arterial",
                    "elementType": "all",
                    "stylers": [
                      {
                        "visibility": "simplified"
                      }
                    ]
                  },
                  {
                    "featureType": "road.arterial",
                    "elementType": "geometry.fill",
                    "stylers": [
                      {
                        "color": "#ffffff"
                      }
                    ]
                  },
                  {
                    "featureType": "road.arterial",
                    "elementType": "labels",
                    "stylers": [
                      {
                        "visibility": "off"
                      }
                    ]
                  },
                  {
                    "featureType": "road.local",
                    "elementType": "all",
                    "stylers": [
                      {
                        "visibility": "simplified"
                      }
                    ]
                  },
                  {
                    "featureType": "road.local",
                    "elementType": "labels",
                    "stylers": [
                      {
                        "visibility": "off"
                      }
                    ]
                  },
                  {
                    "featureType": "transit",
                    "elementType": "all",
                    "stylers": [
                      {
                        "visibility": "off"
                      }
                    ]
                  },
                  {
                    "featureType": "water",
                    "elementType": "all",
                    "stylers": [
                      {
                        "color": "#7ccff0"
                      },
                      {
                        "visibility": "on"
                      }
                    ]
                  },
                  {
                    "featureType": "water",
                    "elementType": "geometry.fill",
                    "stylers": [
                      {
                        "color": "#cfeae4"
                      }
                    ]
                  },
                  {
                    "featureType": "water",
                    "elementType": "labels",
                    "stylers": [
                      {
                        "visibility": "off"
                      }
                    ]
                  }
                ]
          };

          /**
           * Create map
           *
           * @type {exports.ecmaIdentifiers.Map}
           */
          map = new google.maps.Map(document.getElementById('googlemaps'), mapOptions);

          var markers = [];
          var locations = markerPositions;



          for (var i = 0; i < locations.length; i++) {
            var data = locations[i];
            var location = data.position;

            var myLatLng = new google.maps.LatLng(location.lat, location.lng);
            var marker = new google.maps.Marker({
              position: myLatLng,
              map: map,
              icon: {
                url: locations[i].marker,
                size: new google.maps.Size(26, 39),
                origin: new google.maps.Point(0, 0),
                anchor: new google.maps.Point(14, 39)
              },
              title: location.title
            });



            //extend bounds, to fit the map with markers
            bounds.extend(marker.position);
            attachActionToMarker(marker, data);

            markers.push(marker);

          }

          map.fitBounds(bounds);


          console.log(common.template_uri);


          var markerCluster = new MarkerClusterer(map, markers, {
                maxZoom: 9,
                styles : [
                  {
                    textColor: 'white',
                    url: common.template_uri+'/assets/images/cluster_cloud.png',
                    height: 31,
                    width: 45
                  },
                  {
                    textColor: 'white',
                    url: common.template_uri+'/assets/images/cluster_cloud.png',
                    height: 31,
                    width: 45
                  },
                  {
                    textColor: 'white',
                    url: common.template_uri+'/assets/images/cluster_cloud.png',
                    height: 31,
                    width: 45
                  }
                ]
          });

        }
        google.maps.event.addDomListener(window, 'load', showGoogleMaps);


        $(document).on('pjax:send', function(){
            $('#btn-open-content').hide();
            $('#loading-animation').show();
        });
        $(document).on('pjax:complete', function(){
          $('#btn-open-content').show();
          $('#loading-animation').hide();
          document.getElementById('main-container').scrollTop = 0;
          openPanel();
        });

        $('#main-content').live('click', function(){
          openPanel();
        });

      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired

        openPanel = function() {

          $('#btn-open-content').addClass('open');
          $('#main-container').addClass('open-content');
          $('#googlemaps-container').addClass('open');
          $('#map-overlay').addClass('open');
        };

        closePanel = function() {
          document.getElementById('main-container').scrollTop = 0;
          $('#btn-open-content').removeClass('open');
          $('#main-container').removeClass('open-content');
          $('#googlemaps-container').removeClass('open');
          $('#map-overlay').removeClass('open');
        };

        openClose = function() {
          $('#btn-open-content').toggleClass('open');
          $('#main-container').toggleClass('open-content');
          $('#googlemaps-container').toggleClass('open');
          $('#map-overlay').toggleClass('open');
        };

        $('#btn-open-content').click(function(){
          openClose();
        });

        $('#map-overlay.open').live('click', function(){
          openClose();
        });

        openPanel();
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
